<template>
  <div>
    <input type="text" id="focusInput" style="position:absolute;left:-200%;top:0;"/>
    <ShortcutFunction/>
  </div>
</template>

<script>
import ShortcutFunction from '@/components/shortcutFunction'
import { includeLinkList, includeScriptList } from '@/utils/common'
import { CSS_BASEURL, SCRIPT_BASEURL } from '@/utils/enum'

export default {
  name: 'CommonJs',
  components: { ShortcutFunction },
  mounted () {
    includeLinkList([
      CSS_BASEURL + '/shared/commonJs.css'
    ])
    includeScriptList([
      SCRIPT_BASEURL + '/shared/commonJs.js'
    ])
  }
}
</script>

<style scoped>
html {
    height: 100%;
    width: 100%;
}

body {
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
}

label, span {
    font-size: 12px;
}

.LRpadding {
    padding: 0;
}

.l-window-mask {
    opacity: 0;
}

.unSelectImg {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
}

.unColor {
    color: #9c9c9c !important;
}

.unBg {
    background: #ddd !important;
}

</style>
